import {
  flattenSocketNotificationPayload,
  resolvePushTitle,
  resolvePushBody,
} from '../fcm/pushPayloadCore';
import { resolvePushLinkFromData } from '../fcm/pushLinkResolvers';
import { PUSH_CONFIG } from '../fcm/pushConstants';

const pickFirstValue = (...values) => values.find((value) => value != null && value !== '');

/**
 * Maps backend `notification:new` envelope to foreground toast / push normalizer input.
 * @param {object} payload
 * @returns {object}
 */
export const mapSocketNotificationToForegroundDetail = (payload = {}) => {
  const mergedData = flattenSocketNotificationPayload(payload);

  const notificationId = pickFirstValue(
    payload.notificationId,
    payload.notification_id,
    payload._id,
    payload.id,
    mergedData.notificationId,
    mergedData.notification_id
  );
  const type = pickFirstValue(payload.type, mergedData.type);
  const eventType = pickFirstValue(
    payload.eventType,
    payload.notificationType,
    mergedData.eventType,
    mergedData.notificationType
  );
  const title = resolvePushTitle(payload, mergedData);
  const body = resolvePushBody(payload, mergedData);
  const link =
    pickFirstValue(payload.link, payload.openUrl, payload.deepLink) ||
    resolvePushLinkFromData(mergedData, {
      bodyText: body,
      defaultLink: PUSH_CONFIG.DEFAULT_LINK,
    });

  return {
    title,
    body,
    message: body,
    type,
    tag: notificationId,
    notificationId,
    createdAt: payload.createdAt,
    schemaVersion: payload.schemaVersion,
    link,
    data: {
      ...mergedData,
      type: type || mergedData.type,
      eventType: eventType || mergedData.eventType,
      notificationId,
    },
    meta: payload.meta,
  };
};
